export default {
  attributeInserter: false,
  allowCode: false,
  autoFocusBottomRight: true,
  markdownLinks: false,
  allowImage: false,
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowHeading: false,
  allowSubheading: false,
  allowEmoji: true
};